// Third party libraries
import { Link, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
// Local State Functions
import {
  removeCompany,
} from '../../clientStore/companySlice/company-async-thunk';
import {
  getCompanyRemovingStatus,
  setCompanySavingStatus,
  setCompanyLoadingStatus,
  setCompanyRemovingStatus,
} from '../../clientStore/companySlice/company-slice';
// Styles
import styles from './CompanyTableBody.module.css';
import deleteIcon from './../../img/delete.png';


export const CompanyTableBody = ({ tableData }) => {
  const { url } = useRouteMatch();
  const dispatch = useDispatch();
  const history = useHistory();
  const removedStatus = useSelector(getCompanyRemovingStatus);

  useEffect(() => {
    if (removedStatus === 'successed') {
      dispatch(setCompanySavingStatus({ status: 'idle' }));
      dispatch(setCompanyLoadingStatus({ status: 'idle' }));
      dispatch(setCompanyRemovingStatus({ status: 'idle' }));
      history.go(0)
    }
  }, [removedStatus, history, dispatch]);

  return (
    <ul className={styles.list}>
      {tableData.map((data) => {
        return (
          <li className={styles.listItem} key={data._id} className={styles.link}>
            <Link to={`${url}/${data._id}`} className={styles.txt}><span >{data.companyName}</span></Link>
            <span className={styles.txt} onClick={() => window.confirm("Are you sure to delete company with all users?") && dispatch(removeCompany(data._id))}> <img src={deleteIcon} alt="Delete icon" className={styles.icon} /></span>
            <Link to={`${url}/${data._id}`} className={styles.txt}>
              <span className={styles.txt}>
                <input type='checkbox' defaultChecked={data.disabled} className={styles.disabledCheckbox} />
              </span>
            </Link>
            <Link to={`${url}/${data._id}`} className={styles.txt}> <span className={styles.txt}>{new Date(data.createdAt).toDateString()}</span></Link>
            <Link to={`${url}/${data._id}`} className={styles.txt}> <span className={styles.txt}>{new Date(data.updatedAt).toDateString()}</span></Link>
          </li>
        );
      })}
    </ul>
  );
};